/**
 * Hotspot 111 · helpers puros de los avisos del canal Campana en la campana del header.
 */

export type DestinoAviso =
  | { tipo: "interno"; ruta: string }
  | { tipo: "externo"; url: string }
  | null;

/**
 * A dónde lleva el enlace de un aviso. Solo se aceptan rutas internas ("/…", sin "//"
 * que el navegador interpretaría como otro dominio) y URLs http(s); cualquier otro
 * esquema (javascript:, data:…) se descarta. Una URL absoluta del MISMO origen se
 * trata como ruta interna (navegación sin recargar).
 */
export function destinoDeEnlace(enlace: string | null | undefined, origen?: string): DestinoAviso {
  const valor = enlace?.trim();
  if (!valor) return null;
  if (valor.startsWith("/") && !valor.startsWith("//")) return { tipo: "interno", ruta: valor };

  let url: URL;
  try {
    url = new URL(valor);
  } catch {
    return null;
  }
  if (url.protocol !== "http:" && url.protocol !== "https:") return null;
  if (origen && url.origin === origen) {
    return { tipo: "interno", ruta: `${url.pathname}${url.search}${url.hash}` };
  }
  return { tipo: "externo", url: url.toString() };
}

/** Badge combinado de la campana: suma las no vistas de cada fuente habilitada. */
export function totalNoVistas(...conteos: Array<number | undefined>): number {
  return conteos.reduce<number>((acc, n) => acc + (n && n > 0 ? n : 0), 0);
}

/** Estado de una fuente del panel de la campana (subset del `status` de TanStack Query). */
export interface FuenteCampana {
  /** El usuario tiene el permiso que exige su endpoint (si no, nunca se consulta). */
  habilitada: boolean;
  status: "pending" | "error" | "success";
}

/**
 * ¿El panel sigue esperando la PRIMERA respuesta de alguna fuente? Las listas se
 * piden al abrir la campana: mientras tanto se muestra skeleton, no «Sin
 * notificaciones» (falso vacío). Una fuente con error no bloquea el panel.
 */
export function hayFuentePendiente(fuentes: ReadonlyArray<FuenteCampana>): boolean {
  return fuentes.some((f) => f.habilitada && f.status === "pending");
}
